import React, { useEffect } from "react";
import { Grid, Col, Row } from "react-bootstrap";
import WaitlistTable from "components/WaitlistTable/WaitlistTable";
import { Subject } from "rxjs";
import { restoreVisitorToWaitlist } from "services/visits/visits.service";
import { useSelector } from "react-redux";
import useLocalStorage from "hooks/useLocalStorage";

function History(props) {
  const visitSelector = useSelector(state => state.visit);
  const { historyVisitors } = visitSelector;
  const business = useSelector(state => state.business.business);
  const [waitlistFilter, setWaitlistFilter] = useLocalStorage("waitlistFilter", { partySize: null, category: null });
  const [listOrder, setListOrder] = useLocalStorage("waitlistOrder", null);

  useEffect(() => {
    const destroy$ = new Subject();
    return () => {
      destroy$.next(true);
      destroy$.complete();
    };
  });
  return (
    <div className="main-content">
      <Grid fluid>
        <Row>
          <Col md={12}>
            <WaitlistTable
              history={true}
              user={props.user}
              business={business}
              guestList={historyVisitors}
              restoreVisitorToWaitlist={restoreVisitorToWaitlist}
              filter={waitlistFilter}
              setFilter={setWaitlistFilter}
              listOrder={listOrder}
              setListOrder={setListOrder}
            ></WaitlistTable>
          </Col>
        </Row>
      </Grid>
    </div>
  );
}

export default History;
